import services from './services';
import {
	lg,
	cloneDeep,
	util,
	isCorrectVal,
	isDate
} from 'utils';
import {
	GetProvinces,
	GetCitys,
	GetAreas,
} from '@api/commonApi.js';
import areaSelect from 'area-select';
import addOrderDialog from '@pages/SchoolOrder/components/addOrderDialog/index.vue'
import openClassDialog from '../components/openClassDialog/index.vue'
export default {
	components: {
		areaSelect,
		addOrderDialog,
		openClassDialog
	},
	mixins: [services],
	data() {
		return {
			lists: [],
			loading: false,
			pageIndex: 1,
			pageSize: 10,
			totalSize: '',
			pageSizes: [10, 20, 50],
			areaInfo: {
				Provinces_Id: null,
				City_Id: null
			},
			query: this.getFormData(),
			//未开班: 0 部分开班: 1 全部开班: 2 全部 -1
			options: [{
				id: -1,
				label: '全部'
			}, {
				id: 0,
				label: '未开班'
			}, {
				id: 1,
				label: '部分开班'
			}, {
				id: 2,
				label: '全部开班'
			}, ],

		}
	},
	methods: {
		getFormData() {
			return cloneDeep({
				AgentName: "", //代理商
				SchoolName: "", //园所
				ProvId: '',
				City_Id: '',
				OpenStatus: -1
			});
		},
		//查询
		onQuerySubmit() {
			let areaForm = this.$refs.areaForm.getSelectedData();
			this.query.ProvId = areaForm.Provinces_Id;
			this.query.CityId = areaForm.City_Id;
			this.getList();
		},
		// 重置
		onQueryClean() {
			this.query = this.getFormData();
			this.$refs.areaForm.clearResultValue()
			this.getList();
		},
		//导出功能
		download() {
			this.$confirm('确认导出吗？', '提示', {}).then(() => {
				let params = {
					Sid: this.$store.state.sysSid,
					Session: this.$store.state.sysSession
				};
				for (var i in this.query) {
					if (this.query.hasOwnProperty(i)) {
						if (isCorrectVal(this.query[i])) {
							// 去除空格trimAllSpace(str, is_global)  true 为去除所有空格
							if (typeof this.query[i] == 'string') {
								this.query[i] = util.trimAllSpace(this.query[i]);
							}
							params[i] = this.query[i]
						}
					};
				}
				let areaForm = this.$refs.areaForm.getSelectedData();
				this.query.ProvId = areaForm.Provinces_Id;
				this.query.CityId = areaForm.City_Id;
				util.exportToFileV2("api/MeetOrder/GetMeetPassResourceExport", params, this)
			});
		},
		// 开课
		handleOpenClass(row) {

			this.$refs.refOpenClass.show({
				message: row,
				title: '会销开课'
			})
		},
		handleOpenClassSchool(row) {
			console.log(row)
			this.$refs.refOpenClass.show({
				message: row,
				title: '转园开课'
			})
			// this.$refs.refMeetOpenClass.show({
			// 	message: row,
			// 	title: '转园开课'

			// })
		},
		//新增开课
		openClass() {
			this.$refs.refMeetOpenClass.show({
				title: '转会销开课'
			})
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.getList()
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getList();
		}
	},
	created() {
		this.getList();

	},
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/MeetOpenClass/vm.js